<!-- <app-route-header [title]="pageTitle"></app-route-header> -->
<app-hero-image [src]="heroImageUrl"></app-hero-image>
<div *ngIf="introContent">
    <p>
        {{introContent}}
    </p>
</div>
<app-content-block-container [maxBlocks]="MAXBLOCKS" *ngIf="contentBlocks" [contentBlocks]="contentBlocks">
</app-content-block-container>